<template>
  <!-- 研报详情页面 -->
  <div class="bgs">
    <Header></Header>
    <el-breadcrumb class="crumbs" separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>研报详情</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="main">
      <div class="main_left">
        <div class="main_left_top">
          <div class="main_left_left">
            <div class="content_content">{{ details.chinese_title }}</div>
          </div>
          <div class="main_left_right">
            <div class="title">
              {{ details.chinese_title }}
            </div>
            <div class="eng_title">
              {{ details.english_title }}
            </div>
            <div style="border:1px solid #E8E8E8"></div>
            <div class="main_left_right_bottom">
              <div class="List_details">
                <div>发布日期：{{ datas1 }}</div>
                <div class="List_details_r">浏览：45862</div>
              </div>
              <div class="List_details">
                <div>
                  行业：<span style="color:#3463DB;">{{
                    details.industry_name
                  }}</span>
                </div>
                <div class="List_details_r">
                  下载：{{ details.num_download }}
                </div>
              </div>
              <div class="List_details">
                <div>
                  报告形式：<span style="color:#3463DB;">PDF电子版</span>
                </div>
                <div
                  style="display:flex;align-items:center;"
                  class="List_details_r"
                >
                  分享：
                  <img
                    src="../assets/img/weibo_icon.png"
                    style="cursor: pointer;"
                    @click="ShareMicroblog"
                    alt=""
                  />
                </div>
              </div>
              <div class="List_details">
                <div>页数：<span>1</span></div>
                <div class="List_details_r">
                  来源：{{
                    details.com_on == null ? details.nickname : details.com_on
                  }}
                </div>
              </div>
              <div class="List_details" style="margin-top:10px;">
                <div>
                  交易价格：
                  <span v-if="details.is_charge == 1"
                    >RMB
                    <span style="font-size:24px;color:#F3A72F">{{
                      details.price
                    }}</span></span
                  >
                  <span
                    style="font-size:24px;color:#F3A72F"
                    v-if="details.is_charge == 0"
                    >免费</span
                  >
                </div>
              </div>
              <!-- 免费 -->
              <div class="btns" v-if="details.is_charge == 0">
                <div
                  class="btn btn1"
                  @click="Collection(details.id, 1)"
                  v-if="isCollection == true"
                >
                  <img
                    src="../assets/img/shoucang_icon.png"
                    class="imgs_icons"
                    alt=""
                  />
                  <div>收藏</div>
                </div>
                <div
                  class="btn btn1"
                  @click="Collection(details.id, 0)"
                  v-if="isCollection == false"
                >
                  <img
                    src="../assets/img/shoucang_icon.png"
                    class="imgs_icons"
                    alt=""
                  />
                  <div>已收藏</div>
                </div>
                <a
                  v-if="token != null"
                  :href="details.report_file"
                  target="_blank"
                  download="研报.pdf"
                >
                  <div class="btn btn2">
                    <img
                      src="../assets/img/xiazai_icon.png"
                      class="imgs_icons"
                      alt=""
                    />
                    <div>下载</div>
                  </div>
                </a>
                <div v-if="token == null" @click="is_login" class="btn btn2">
                  <img
                    src="../assets/img/xiazai_icon.png"
                    class="imgs_icons"
                    alt=""
                  />
                  <div>下载</div>
                </div>
              </div>
              <!-- 收费 -->
              <div class="btns" v-if="details.is_charge == 1">
                <div
                  class="btn btn1"
                  @click="Collection(details.id, 1)"
                  v-if="isCollection == true"
                >
                  <img
                    src="../assets/img/shoucang_icon.png"
                    class="imgs_icons"
                    alt=""
                  />
                  <div>收藏</div>
                </div>
                <div
                  class="btn btn1"
                  @click="Collection(details.id, 0)"
                  v-if="isCollection == false"
                >
                  <img
                    src="../assets/img/shoucang_icon.png"
                    class="imgs_icons"
                    alt=""
                  />
                  <div>已收藏</div>
                </div>
                <div class="btn btn3" @click="dialogFormVisible = true">
                  <img
                    src="../assets/img/zixun_icon.png"
                    class="imgs_icons"
                    alt=""
                  />
                  <div>咨询</div>
                </div>
                <div
                  class="btn btn4"
                  @click="ISzhifu()"
                  v-if="details.status == 0"
                >
                  <img
                    src="../assets/img/goumai_icon.png"
                    class="imgs_icons"
                    alt=""
                  />
                  <div>立即购买</div>
                </div>
                <!-- @click="downloadFun" -->
                <a
                  v-if="token != null"
                  :href="details.report_file"
                  target="_blank"
                  download="研报.pdf"
                >
                  <div class="btn btn4" v-if="details.status == 1">
                    <img
                      src="../assets/img/xiazai_icon.png"
                      class="imgs_icons"
                      alt=""
                    />
                    <div style="color:#fff;">下载</div>
                  </div>
                </a>
                <div class="btn btn4" v-if="token == null" @click="is_login">
                  <img
                    src="../assets/img/xiazai_icon.png"
                    class="imgs_icons"
                    alt=""
                  />
                  <div style="color:#fff;">下载</div>
                </div>
              </div>
              <!-- 二维码弹窗 -->
              <div class="_alert" v-show="visible == true">
                <div class="wind-alert">
                  <div class="wind-alert-bg" @click="close"></div>
                  <div class="wind-alert-dialog animate-scale">
                    <div id="qrcode" ref="qrcode">
                      <div class="qrcode_title">请用手机扫码完成支付!</div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- 弹窗 -->
              <el-dialog
                title="-我要咨询-"
                :close-on-press-escape="false"
                :close-on-click-modal="false"
                :visible.sync="dialogFormVisible"
              >
                <div style="margin-bottom:20px;display:flex;">
                  <span
                    style="display:inline-block;width:75px;text-align:right;"
                    >研报名称：</span
                  >
                  <span
                    style="margin-left:15px;width:355px;overflow:hidden;text-overflow: ellipsis;display:-webkit-box;-webkit-line-clamp:1;-webkit-box-orient: vertical;"
                    >{{ details.chinese_title }}</span
                  >
                </div>
                <el-form :model="form" :rules="formRule" ref="formData">
                  <el-form-item
                    label="联系人："
                    prop="name"
                    :label-width="formLabelWidth"
                  >
                    <el-input v-model="form.name" autocomplete="off"></el-input>
                  </el-form-item>
                  <el-form-item
                    label="联系电话："
                    prop="namephone"
                    :label-width="formLabelWidth"
                  >
                    <el-input
                      v-model="form.namephone"
                      autocomplete="off"
                    ></el-input>
                  </el-form-item>
                  <el-form-item
                    label="验证码："
                    prop="code"
                    :label-width="formLabelWidth"
                  >
                    <div style="display:flex">
                      <el-input
                        v-model="form.code"
                        style="width:150px;margin-right:50px;"
                        autocomplete="off"
                      >
                      </el-input>
                      <el-button @click="SendCode" :disabled="disabled">{{
                        SCode
                      }}</el-button>
                    </div>
                  </el-form-item>
                  <el-form-item
                    label="咨询留言："
                    prop="offer"
                    :label-width="formLabelWidth"
                  >
                    <el-input
                      type="textarea"
                      resize="none"
                      v-model="form.offer"
                      autocomplete="off"
                    ></el-input>
                  </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                  <!-- <el-button @click="dialogFormVisible = false">取 消</el-button> -->
                  <el-button type="primary" @click="OnSubmit('formData')"
                    >提交</el-button
                  >
                </div>
              </el-dialog>
            </div>
          </div>
        </div>
        <div style="border-bottom:1px solid #e8e8e8;"></div>
        <div class="main_left_content">
          <div class="main_left_content_title">
            <img src="../assets/img/jianjie_icon.png" alt="" />
            <div style="font-weight:550;">研报简介</div>
          </div>
          <div class="contents">{{ details.report_profile }}</div>
        </div>
        <div style="border-bottom:1px solid #e8e8e8;"></div>
        <div class="main_left_bottom">
          <div class="main_left_content_title">
            <img src="../assets/img/mulu_icon.png" alt="" />
            <div style="font-weight:550;">目录章节</div>
          </div>
          <div class="contents">
            {{ details.contents_section }}
          </div>
        </div>
      </div>

      <div class="main_fixed">
        <div class="main_right">
          <div class="Search">
            <img src="../assets/img/search_icon.png" class="dw_img" alt="" />
            <input
              type="text"
              class="ipt"
              @keyup.enter="Go_search"
              v-model="search"
              placeholder="搜研报"
            />
            <button class="Go_search" @click="Go_search">搜索</button>
          </div>
          <div class="PersonalProfile">
            <div class="userimg" @click="Go_AuthorsHome">
              <img
                class="border_img"
                v-if="details.user_role == 1"
                src="@/assets/img/zhuanjia_daimg.png"
                alt=""
              />
              <img
                class="border_img"
                v-if="details.user_role == 2"
                src="@/assets/img/jigou_daimg.png"
                alt=""
              />
              <img class="content_img" :src="details.headimg" alt="" />
            </div>
            <div
              style="text-align:center;margin:20px 0 17px;font-size:18px;font-weight:800;color:#333333;"
            >
              {{ details.nickname }}
            </div>
            <div
              style="text-align:center;font-size:16px;color:#666666;line-height:30px;"
            >
              {{ details.chinese_title }}
            </div>
            <div v-if="token != null">
              <div v-if="isuid.id != details.uid">
                <div class="guanzhu1" v-if="isguanzhu == true" @click="guanzhu">
                  关注
                </div>
                <div class="guanzhu2" v-if="isguanzhu == false" @click="quguan">
                  已关注
                </div>
              </div>
            </div>
            <div v-if="token == null">
              <div class="guanzhu1" v-if="isguanzhu == true" @click="guanzhu">
                关注
              </div>
              <div class="guanzhu2" v-if="isguanzhu == false" @click="quguan">
                已关注
              </div>
            </div>
          </div>
          <div class="main_right_list">
            <div class="main_right_list_title">
              <div class="shugang"></div>
              <div>相关研报</div>
            </div>
            <div
              class="main_right_list_l"
              v-for="(item, index) in RelevantInformations"
              :key="index"
              @click="Go_ResearchReportDetails(item.id)"
            >
              <div class="yuandian">●</div>
              <div class="titles">{{ item.chinese_title }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Footer></Footer>
  </div>
</template>

<script>
import QRCode from "qrcodejs2";
import Header from "../components/Header.vue";
import Footer from "../components/Footer.vue";
import download from "downloadjs";
import { Details } from "@/api/api";
import Axios from "axios";
export default {
  metaInfo() {
    // 研报详情
    return {
      title:
        this.details.chinese_title == undefined
          ? "研报详情"
          : this.details.chinese_title + "_驱动中国研究院",
      meta: [
        {
          name: "keywords",
          content: this.details.report_profile,
        },
        {
          name: "description",
          content: this.details.chinese_title,
        },
      ],
    };
  },
  inject: ["reload"],
  name: "ResearchReportDetails",
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      isuid: JSON.parse(localStorage.getItem("userInfo")),
      title: "提示",
      content: "",
      btn: "确定",
      visible: false,
      dialogVisible: false,
      token: localStorage.getItem("token"),
      search: "",
      num: 0,
      dialogTableVisible: false,
      dialogFormVisible: false,
      form: {
        name: "",
        namephone: "",
        code: "",
        offer: "",
      },
      formRule: {
        name: [{ required: true, message: "请输入联系人", trigger: "blur" }],
        namephone: [
          { required: true, message: "请输入联系电话", trigger: "blur" },
        ],
        code: [{ required: true, message: "请输入验证码", trigger: "blur" }],
        offer: [{ required: true, message: "请输入咨询留言", trigger: "blur" }],
      },
      formLabelWidth: "120px",
      SCode: "发送验证码",
      disabled: false,
      time: 60,
      details: "",
      datas1: "",
      isguanzhu: true,
      RelevantInformations: [],
      isCollection: true,
      QrCodeaddress: "", //二维码地址
      QrCodeordernumber: "", //订单号
      timeout: "", //定时器
    };
  },
  created() {
    this.Pay(this.$route.query.id);
    this.RelevantInformation();
    ////////console.log(this.$route.query.id);
    this.Details(this.$route.query.id);
    this.CollectionStatus(this.$route.query.id); //是否收藏状态
    this.qrcode();
  },
  mounted() {},
  //  watch: {
  //   $route(n, o) {
  //     if (n.fullPath !== o.fullPath) {
  //       //监听路由参数是否变化
  //      this.reload();
  //     }
  //   },
  // },
  methods: {
    is_login() {
      this.$message.warning("请您登录以后再下载");
    },
    Go_AuthorsHome() {
      this.$router.push({
        name: "AuthorsHome",
        query: { id: this.details.uid },
      });
    },
    downloadFun() {
      download(
        "https://tsadmin.qudong.com/data/upload/tousu/20211029/c98eed5beb5ae1c4161e0d1524314a21.jpg"
      );
    },
    // 支付
    Pay(id) {
      if (this.token != null) {
        Axios({
          method: "post",
          url: "https://researchadmin.qudong.com/api/wx_pay/pay",
          params: {
            id: id,
          },
          headers: {
            token: this.token,
          },
        }).then((res) => {
          ////////console.log(res);
          this.QrCodeaddress = res.data.data.url;
          this.QrCodeordernumber = res.data.data.order_number;
        });
      }
    },
    // 收藏状态
    CollectionStatus(id) {
      if (this.token != null) {
        Axios({
          method: "get",
          url: "https://researchadmin.qudong.com/api/favorite/info_status",
          params: {
            cid: id,
            type: 2,
          },
          headers: {
            token: this.token,
          },
        }).then((res) => {
          if (res.data.data == 0) {
            this.isCollection = true;
          } else {
            this.isCollection = false;
          }
        });
      }
    },

    // 跳转相关研报详情
    Go_ResearchReportDetails(id) {
      this.$router.push({ name: "ResearchReportDetails", query: { id: id } });
      this.reload();
    },
    qrcode() {
      var that = this;
      setTimeout(function() {
        new QRCode("qrcode", {
          width: 200,
          height: 200,
          text: that.QrCodeaddress, // 二维码地址
          colorDark: "#000",
          colorLight: "#fff",
        });
      }, 1800);
    },

    // 分享微博
    ShareMicroblog() {
      let urls =
        "http://research.qudong.com/ResearchReportDetails?id=" +
        this.details.id;
      window.open(
        "https://service.weibo.com/share/share.php?url=" +
          encodeURIComponent(urls) +
          "&title=" +
          this.details.chinese_title +
          "&summary=" +
          this.details.chinese_title
      );
    },
    // 收藏
    Collection(id, num) {
      ////////console.log(num);
      ////////console.log(id);
      if (this.token != null) {
        Axios({
          method: "post",
          url: "https://researchadmin.qudong.com/api/favorite/report_save",
          headers: {
            token: this.token,
          },
          data: {
            cid: id,
            type: num,
          },
        }).then((res) => {
          ////////console.log(res);
          this.isCollection = !this.isCollection;
          if (num == 1) {
            this.$message.success("收藏成功");
          } else {
            this.$message.warning("取消收藏");
          }
        });
      } else {
        this.$message.warning("请您登录以后再收藏!");
      }
    },
    // 相关研报
    RelevantInformation() {
      Axios({
        method: "get",
        url: "https://researchadmin.qudong.com/api/report_relevant",
        params: {},
      }).then((res) => {
        ////////console.log(res.data.data);
        this.RelevantInformations = res.data.data;
      });
    },
    close() {
      this.visible = false;
      clearInterval(this.timeout);
      //    this._promise &&  this._promise.resolve()
    },
    ISzhifu() {
      var that = this;
      if (this.token != null) {
        this.visible = true;
        if (this.visible == true) {
          this.timeout = setInterval(() => {
            Axios({
              method: "post",
              url: "https://researchadmin.qudong.com/api/wx_pay/wxpaynotify",
              params: {
                report_id: this.details.id,
                out_trade_no: that.QrCodeordernumber,
              },
              headers: {
                token: this.token,
              },
            }).then((res) => {
              ////////console.log(res);
              if (res.data.code == 200) {
                if (res.data.data == "NOTPAY") {
                  ////////console.log("没支付");
                } else if (res.data.data == "SUCCESS") {
                  this.$message.success("支付成功！");
                  clearInterval(this.timeout);
                  this.reload();
                }
              }
            });
          }, 3000);
        }
      } else {
        this.$message.warning("请您先登录");
      }
    },
    // 关注
    guanzhu() {
      if (this.token != null) {
        Axios({
          method: "post",
          url: "https://researchadmin.qudong.com/index/detail/relation",
          params: {
            id: this.details.uid,
          },
          headers: {
            token: this.token,
          },
        }).then((res) => {
          ////////console.log(res);
          if (res.data.code == 200) {
            this.isguanzhu = false;
            this.$message.success("关注成功");
          }
        });
      } else {
        this.$message.warning("请您登录以后关注");
      }
    },
    quguan() {
      Axios({
        method: "post",
        url: "https://researchadmin.qudong.com/index/detail/relation",
        params: {
          id: this.details.uid,
        },
        headers: {
          token: this.token,
        },
      }).then((res) => {
        ////////console.log(res);
        if (res.data.code == 201) {
          this.isguanzhu = true;
          this.$message.success("取消关注");
        }
      });
    },
    // 详情页面展示
    Details(id) {
      if (this.token == null) {
        Axios({
          method: "get",
          url: "https://researchadmin.qudong.com/api/update_data_one",
          params: {
            id: id,
            type: 2,
          },
        }).then((res) => {
          ////////console.log(res);
          this.details = res.data.data;
          this.datas1 = this.details.create_time.slice(0, 11);
        });
      } else {
        Details({
          id: id,
          type: 2,
        }).then((res) => {
          ////////console.log(res.data.data);
          if (res.data.code == 200) {
            this.details = res.data.data;
            this.datas1 = this.details.create_time.slice(0, 11);
            Axios({
              method: "post",
              url:
                "https://researchadmin.qudong.com/index/detail/relation_status",
              params: {
                id: this.details.uid,
              },
              headers: {
                token: this.token,
              },
            }).then((res) => {
              ////////console.log(res.data.data);
              if (res.data.data == 0) {
                this.isguanzhu = true;
              } else {
                this.isguanzhu = false;
              }
            });
          }
        });
      }
    },
    // 提交
    OnSubmit(formData) {
      var that = this;
      this.$refs[formData].validate((valid) => {
        if (valid) {
          var NewReg = /^1[3456789]\d{9}$/; //手机正则
          ////////console.log(valid);
          if (!NewReg.test(this.form.namephone)) {
            return that.$message.warning("请输入正确的手机号码");
          }
          // 验证验证码接口

          // 提交接口
          Axios({
            method: "post",
            url: "https://researchadmin.qudong.com/api/want_report",
            params: {
              report_name: this.details.chinese_title,
              report_id: this.$route.query.id,
              contacts: this.form.name,
              code: this.form.code,
              phone: this.form.namephone,
              Information_message: this.form.offer,
            },
          }).then((res) => {
            ////////console.log(res);
            if (res.data.code == 200) {
              this.form = {};
              this.$message.success("提交成功");
              this.dialogFormVisible = false;
            } else {
              this.$message.error(res.data.msg);
            }
          });
        }
      });
    },
    // 验证码
    SendCode() {
      var NewReg = /^1[3456789]\d{9}$/; //手机正则
      ////////console.log(this.form.namephone);
      var that = this;
      if (!this.form.namephone) {
        return that.$message.warning("手机号不能为空");
      }
      if (!NewReg.test(this.form.namephone)) {
        return that.$message.warning("请输入正确的手机号码");
      }
      var phone4 = this.form.namephone.substr(this.form.namephone.length - 4);
      Axios({
        method: "get",
        url: "https://researchadmin.qudong.com/api/get_code",
        params: {
          phone: this.form.namephone,
          type: 1,
        },
      }).then((res) => {
        ////////console.log(res);
        if (res.data.code == 0) {
          that.$message.success(res.data.msg);
          that.SCode = that.time + "s";
          var timeFun = setInterval(function() {
            that.disabled = true;
            that.time--;
            that.SCode = that.time + "s";
            if (that.time == 0) {
              that.SCode = that.timer + "s";
              that.SCode = "发送验证码";
              clearInterval(timeFun);
              that.disabled = false;
              that.time = 60;
            }
          }, 1000);
        }else{
          this.$message.error(res.data.msg)
        }
      });
    },
    // 提交
    // OnSubmit(formData) {
    //   var that = this;
    //   this.$refs[formData].validate((valid) => {
    //     if (valid) {
    //       var NewReg = /^1[3456789]\d{9}$/; //手机正则
    //       ////////console.log(valid);
    //       if (!NewReg.test(this.form.namephone)) {
    //         return that.$message.warning("请输入正确的手机号码");
    //       }
    //       // 验证验证码接口
    //       Axios({
    //         method: "post",
    //         url: "https://weixin.qudong.com/api/user/check_code_no",
    //         params: {
    //           phone: this.form.namephone,
    //           code: this.form.code,
    //         },
    //       }).then((res) => {
    //         ////////console.log(res);
    //         if (res.data.code == 200) {
    //           // 提交接口
    //           Axios({
    //             method: "post",
    //             url: "https://researchadmin.qudong.com/api/want_report",
    //             params: {
    //               report_id: this.$route.query.id,
    //               contacts: this.form.name,
    //               report_name: this.details.chinese_title,
    //               phone: this.form.namephone,
    //               Information_message: this.form.offer,
    //             },
    //           }).then((res) => {
    //             ////////console.log(res);
    //             if (res.data.code == 200) {
    //               this.form = {};
    //               this.$message.success("提交成功");
    //               // this.dialogFormVisible = false;
    //             } else {
    //               this.$message.error(res.data.msg);
    //             }
    //           });
    //         } else {
    //           this.$message.error(res.data.msg);
    //         }
    //       });
    //     }
    //   });
    // },
    // 验证码
    // SendCode() {
    //   var NewReg = /^1[3456789]\d{9}$/; //手机正则
    //   ////////console.log(this.form.namephone);
    //   var that = this;
    //   if (!this.form.namephone) {
    //     return that.$message.warning("手机号不能为空");
    //   }
    //   if (!NewReg.test(this.form.namephone)) {
    //     return that.$message.warning("请输入正确的手机号码");
    //   }
    //   var phone4 = this.form.namephone.substr(this.form.namephone.length - 4);
    //   Axios({
    //     method: "post",
    //     url: "https://weixin.qudong.com/api/user/security_code",
    //     params: {
    //       phone_num: this.form.namephone,
    //       captcha: that.$md5(phone4),
    //     },
    //   }).then((res) => {
    //     ////////console.log(res);
    //     if (res.data.code == 200) {
    //       that.$message.success(res.data.data);
    //       that.SCode = that.time + "s";
    //       var timeFun = setInterval(function () {
    //         that.disabled = true;
    //         that.time--;
    //         that.SCode = that.time + "s";
    //         if (that.time == 0) {
    //           that.SCode = that.timer + "s";
    //           that.SCode = "发送验证码";
    //           clearInterval(timeFun);
    //           that.disabled = false;
    //           that.time = 60;
    //         }
    //       }, 1000);
    //     }
    //   });
    // },
    Go_search() {
      if (this.search == "") {
        return this.$message.warning("输入内容不能为空!");
      } else {
        this.$router.push({
          name: "Searchreport",
          query: { search: this.search },
        });
      }
    },
  },
};
</script>

<style scoped>
.bgs {
  background: #f5f7f9;
}

.crumbs {
  width: 1200px;
  margin: 20px auto;
  padding-left: 50px;
}
.main {
  width: 1200px;
  margin: 0 auto 80px;
  display: flex;
  justify-content: space-between;
}

.main_right {
  width: 320px;
  position: sticky;
  top: 20px;
  right: 0;
}

.ipt {
  width: 242px;
  height: 34px;
  border: 1px solid #3463db;
  padding-left: 30px;
}
.Go_search {
  width: 77px;
  height: 36px;
  background: #3463db;
  border: none;
  color: #fff;
}
.Search {
  display: flex;
  position: relative;
}
.dw_img {
  position: absolute;
  top: 9px;
  left: 10px;
  width: 15px;
  height: 17px;
}
.main_right_list {
  width: 320px;
  height: 430px;
  margin-top: 21px;
  background: #fff;
}
.main_right_list .shugang {
  width: 4px;
  height: 28px;
  background: #3463db;
  margin-right: 10px;
}
.main_right_list_title {
  width: 320px;
  height: 49px;
  display: flex;
  align-items: center;
  color: #3463db;
  border: 1px solid #e8e8e8;
}
.main_right_list_l {
  display: flex;
  align-items: center;
  padding: 8px 10px;
  cursor: pointer;
}
.main_right_list_l .yuandian {
  margin-right: 10px;
  color: #999999;
}
.titles {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #666666;
  -webkit-box-orient: vertical;
}
/* .main_fixed{
    position:relative;
} */

/* 左侧 */
.main_left {
  width: 850px;
  background: #fff;
}
.main_left_top {
  display: flex;
  padding: 34px 20px;
}
.main_left_left {
  width: 328px;
  height: 389px;
  background-image: url("../assets/img/shu_bg.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  margin-right: 32px;
}
.content_content {
  font-size: 12px;
  width: 200px;
  margin-top: 73px;
  padding: 10px 15px;
  margin-left: 80px;
  font-weight: 600;
  line-height: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 5;
  -webkit-box-orient: vertical;
}
.main_left_right {
  width: 480px;
}
.main_left_right .title {
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: 800;
  line-height: 30px;
  color: #333333;
  margin-bottom: 19px;
}
.main_left_right .eng_title {
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 800;
  color: #666666;
  line-height: 20px;
  margin-bottom: 20px;
}
.main_left_right_bottom {
  /* display:flex;
    justify-content: space-between; */
}
.List_details {
  display: flex;
  margin-top: 15px;
  justify-content: space-between;
  align-items: center;
  font-size: 13px;
}
.List_details_r {
  width: 162px;
  margin-right: 30px;
}
.btns {
  margin-top: 29px;
  display: flex;
  flex-wrap: wrap;
}
.btn {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #ffffff;
  margin-right: 20px;
  cursor: pointer;
  margin-bottom: 10px;
}
.btn1 {
  width: 120px;
  height: 42px;
  background: #45bd35;
  border-radius: 6px;
}
.btn2 {
  width: 120px;
  height: 42px;
  background: #3463db;
  border-radius: 6px;
}
.btn3 {
  width: 120px;
  height: 42px;
  background: #3463db;
  border-radius: 6px;
}
.btn4 {
  width: 120px;
  height: 42px;
  background: #f3a72f;
  border-radius: 6px;
}
.imgs_icons {
  margin-right: 9px;
}
.main_left_content {
  padding: 26px 20px;
}
.main_left_content_title {
  display: flex;
}
.main_left_content_title img {
  margin-right: 16px;
}
.contents {
  margin-top: 20px;
  word-wrap: break-word;
  white-space: pre-wrap;
  color: #333;
  line-height: 28px;
  text-align: justify;
}
.main_left_bottom {
  padding: 28px 21px;
}
>>> .el-dialog {
  width: 500px !important;
}
>>> .el-form-item__label {
  width: 100px !important;
}
>>> .el-form-item__content {
  margin-left: 100px !important;
}
>>> .el-dialog__header {
  border-bottom: 2px solid #3463db;
  text-align: center;
}
>>> .dialog-footer {
  display: flex;
  justify-content: center;
}
>>> .el-button--primary {
  width: 160px;
}
>>> .el-dialog__title {
  color: #3463db;
}
>>> .el-textarea__inner {
  height: 80px;
}
.PersonalProfile {
  width: 248px;
  background: #fff;
  padding: 16px 36px;
  margin-top: 21px;
}
.userimg {
  position: relative;
  width: 96px;
  height: 100px;
  cursor: pointer;
  margin: 0 auto;
}
.border_img {
  width: 96px;
  height: 100px;
  position: relative;
  z-index: 111;
}
.content_img {
  position: absolute;
  border-radius: 50%;
  width: 81px;
  top: 17px;
  left: 3px;
  height: 82px;
}
.guanzhu1 {
  width: 120px;
  height: 40px;
  border: 1px solid #3463db;
  border-radius: 6px;
  text-align: center;
  line-height: 40px;
  cursor: pointer;
  color: #3463db;
  margin: 24px auto 10px;
}
.guanzhu2 {
  width: 120px;
  height: 40px;
  background: #e8e8e8;
  border: 1px solid #e8e8e8;
  border-radius: 6px;
  text-align: center;
  line-height: 40px;
  cursor: pointer;
  color: #999999;
  margin: 24px auto 10px;
}

.wind-alert-dialog {
  top: 30%;
  width: 80%;
  left: 50%;
  opacity: 1;
  position: fixed;
  margin-left: -40%;
  font-size: 14px;
  text-align: center;
  font-family: "Microsoft Yahei";
  background: #ffffff;
  border-radius: 8px;
  z-index: 999999999;
  box-sizing: content-box;
}

.wind-alert-bg {
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0.3;
  display: block;
  position: fixed;
  z-index: 999999998;
  background-color: #000000;
}

.wind-alert-title {
  font-size: 17px;
  padding: 20px 5px 0;
}

.wind-alert-content {
  padding: 5px 15px 20px 15px;
  border-bottom: 1px solid #ededed;
}

.wind-alert-btn {
  color: #0582cd;
  font-size: 15px;
  line-height: 40px;
  font-weight: bold;
}

.animate-scale {
  animation-name: scale;
  animation-duration: 0.375s;
}

@keyframes scale {
  0% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
}
#qrcode {
  top: 40%;
  width: 250px;
  height: 300px;
  left: 40%;
  opacity: 1;
  position: fixed;
  font-size: 14px;
  text-align: center;
  font-family: "Microsoft Yahei";
  background: #ffffff;
  border-radius: 8px;
  z-index: 999999999;
  box-sizing: content-box;
}
>>> #qrcode img {
  margin: 25px auto !important;
}
.qrcode_title {
  font-size: 20px;
  color: #f34;
  margin-top: 20px;
}
</style>